<mat-divider class="static-divider"></mat-divider>
<div class="message">{{ message }}</div>
